// extracted by css-extract-rspack-plugin
export default {"cls1":"Spinner-cls1_m6c","cls2":"Spinner-cls2_4nq Spinner-cls1_m6c","spin":"Spinner-spin_lGe","blue":"Spinner-blue_uUd"};